// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"a612dd89","567":"eda32526"}[chunkId] + ".chunk.css";
};